'use client';

import { createContext, useContext } from 'react';

import type { SheetContextType } from '../types';

export const SheetContext = createContext<SheetContextType | undefined>(undefined);

export const useSheetContext = () => {
  const context = useContext(SheetContext);
  if (!context) throw Error('Sheet context error');
  return context;
};
